import { memo, ReactElement } from 'react';
import { useAtomValue } from 'jotai';
import { jobNumbersAtomFamily } from '../atoms/settingAtoms';
import { PanelJobNumberCount } from './styles';

interface Props {
  advertisementCode: string;
}

// 折りたたむと仕事Noが見えなくなるため、登録件数を見出しに出す。入力途中の行は件数に含めない。
const AdvertisementPanelLabel = memo(function AdvertisementPanelLabel({ advertisementCode }: Props): ReactElement {
  const rows = useAtomValue(jobNumbersAtomFamily(advertisementCode));
  const committedCount = rows.filter(row => row.status === 'committed').length;

  return (
    <>
      広告コード: {advertisementCode}
      <PanelJobNumberCount>{committedCount.toLocaleString()}件</PanelJobNumberCount>
    </>
  );
});

export default AdvertisementPanelLabel;
